/* eslint-disable react/display-name */
import * as React from 'react';

const ChevronLeft = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      d="M6.7,8l5.2,5.4a1.22,1.22,0,0,1,0,1.6l-.1.1h0a.94.94,0,0,1-1.5,0L4.1,8.8A1.6,1.6,0,0,1,3.8,8a1.14,1.14,0,0,1,.3-.8L10.3.9h0a.94.94,0,0,1,1.5,0l.1.1a1.22,1.22,0,0,1,0,1.6Z"
      style={{ fill: 'inherit' }}
    />
  </svg>
);

export default ChevronLeft;
